import DocumentSetsGated from './DocumentSetsGated';

export default DocumentSetsGated;
